// extracted by mini-css-extract-plugin
export default {"starRating":"RatingInputStars_starRating__J35pj","star":"RatingInputStars_star__U--nu","filled":"RatingInputStars_filled__QcCNQ","readOnly":"RatingInputStars_readOnly__Quxky"};